import {
  getProfileLastTouch,
  setProfileLastTouch,
  setProfileLastTouchFavorited,
} from 'utils/Socialization';
import {
  createProfileService,
  deleteProfileService,
  editProfileService,
  getAvatarCollectionsService,
  getProfilesService,
} from '../services/profile.services';
import {
  CLEAR_PROFILE_FORM,
  CREATE_PROFILE_SUCCESS,
  GET_AVATARS_COLLECTIONS,
  GET_PROFILES_INFO,
  HIDE_PROFILE_LOADER,
  SET_IS_LOADING_PROFILES,
  SET_PROFILE_LAYOUT_TYPE,
  SHOW_PROFILE_LOADER,
  UPDATED_PROFILE_INFO,
} from './profile.types';

export const getAvatarsCollection = () => async dispatch => {
  try {
    const { data: collectionResp } = await getAvatarCollectionsService();

    if (collectionResp?.status !== 200)
      throw new Error('Error al obtener la coleccion de avatars');

    dispatch({
      type: GET_AVATARS_COLLECTIONS,
      payload: collectionResp.response.avatars,
    });
  } catch (error) {
    console.log(error);
  }
};

export const getProfiles = ({
  user_token,
  gamification_id,
}) => async dispatch => {
  try {
    const { data: profilesResponse } = await getProfilesService({
      user_token,
      gamification_id,
    });
    if (profilesResponse?.msg === 'ERROR')
      throw new Error('Error al obtener la informacion de perfiles');

    dispatch({
      type: GET_PROFILES_INFO,
      payload: profilesResponse.response.data,
    });

    dispatch({
      type: SET_IS_LOADING_PROFILES,
      payload: false,
    });
  } catch (error) {
    dispatch({
      type: GET_PROFILES_INFO,
      payload: [],
    });
    dispatch({
      type: SET_IS_LOADING_PROFILES,
      payload: false,
    });
    console.log(error, "PROFILES GM");
  }
};

export const createNewProfile = ({ user_image, firstname, is_kids }) => async (
  dispatch,
  getState,
) => {
  try {
    const user = getState().user;
    if (!user.token) return;

    const profileParams = {
      user_image,
      firstname,
      user_token: user.token,
      lasttouch: getProfileLastTouch(),
      is_kids: is_kids ? 'true' : 'false',
    };

    const profileBody = {
      user_image,
      is_kids: is_kids ? 'true' : 'false',
      user_token: user.token,
    };
    const { data: createProfileResp } = await createProfileService({
      params: profileParams,
      body: profileBody,
    });

    if (createProfileResp?.errors) throw new Error('Error al crear perfil');

    if (createProfileResp?.response?.lasttouch) {
      if (createProfileResp.response.lasttouch.profile)
        setProfileLastTouch(createProfileResp.response.lasttouch.profile);
      if (createProfileResp.response.lasttouch?.favorited)
        setProfileLastTouchFavorited(
          createProfileResp.response.lasttouch.favorited,
        );
    }

    dispatch({
      type: CREATE_PROFILE_SUCCESS,
      payload: {
        newMembers: createProfileResp.response.data.members,
        newLayout: 'SELECT_PROFILE',
      },
    });
    dispatch(clearProfileForm());
  } catch (error) {
    console.log(error);
  }
};

export const editProfile = ({
  user_image,
  firstname,
  is_kids,
  gamification_id,
}) => async (dispatch, getState) => {
  try {
    const user = getState().user;
    if (!user.token) return;

    const paramsToEdit = {
      user_image,
      firstname,
      user_token: user.token,
      gamification_id,
      is_kids: is_kids ? 'true' : 'false',
    };

    const bodyToEdit = {
      user_image,
      is_kids: is_kids ? 'true' : 'false',
      user_token: user.token,
      firstname,
    };

    const { data: editedResp } = await editProfileService({
      params: paramsToEdit,
      body: bodyToEdit,
    });

    if (editedResp?.errors) throw new Error('Error al editar perfil');

    const { lasttouch, ...rest } = editedResp?.response;

    if (lasttouch?.profile) {
      setProfileLastTouch(lasttouch.profile);
    }

    dispatch({ type: UPDATED_PROFILE_INFO, payload: { ...rest } });
    dispatch({ type: SET_PROFILE_LAYOUT_TYPE, payload: 'MANAGE_PROFILES' });
  } catch (error) {
    console.log('ERROR', error);
  }
};

export const deleteProfile = ({ gamification_id }) => async (
  dispatch,
  getState,
) => {
  const user = getState().user;
  if (!user.token) return;

  const paramsToEdit = {
    user_token: user.token,
    gamification_id,
  };

  const { data: deleteResponse } = await deleteProfileService({
    params: paramsToEdit,
    body: {
      user_token: user.token,
    },
  });

  if (deleteResponse?.errors) throw new Error('Error al eliminar');

  const { data, lasttouch } = deleteResponse.response;

  if (lasttouch?.profile) {
    setProfileLastTouch(lasttouch.profile);
  }
  dispatch({ type: GET_PROFILES_INFO, payload: data });
  dispatch({ type: SET_PROFILE_LAYOUT_TYPE, payload: 'MANAGE_PROFILES' });
  try {
  } catch (error) {
    console.log(error);
  }
};

export const clearProfileForm = () => dispatch => {
  dispatch({
    type: CLEAR_PROFILE_FORM,
  });
};

export const showProfileLoader = () => dispatch => {
  dispatch({
    type: SHOW_PROFILE_LOADER,
  });
};

export const hideProfileLoader = () => dispatch => {
  dispatch({
    type: HIDE_PROFILE_LOADER,
  });
};
